@if (isLoading) {
<div>
  <mat-spinner
    diameter="{{ diameter }}"
    color="{{ spinnerColor }}"
    class="center-content"
  ></mat-spinner>
  @if (showText) {
<p class="center-content">{{ loadingText }}</p>
}
</div>
}